import * as React from "react";
import Integrations from "../components/block-integrations/block-integrations";
import Subscription from "../components/block-subscription/block-subscription";
import CookieConsent from "../components/cookie-consent/cookie-consent";
import Footer from "../components/footer/footer";
import Header from "../components/header/header";
import Hero from "../components/intro/intro";

interface IBasicLayoutProps {
  readonly showHeader?: boolean;
  readonly showHero?: boolean;
  readonly showIntegrations?: boolean;
  readonly showCta?: boolean;
  readonly showFooter?: boolean;
  readonly heroTitle: string;
  readonly heroSubtitle?: string;
  readonly variableComponent: any;
  readonly priceComponent?: boolean;
  readonly pageContent?: any;
}

class BasicLayout extends React.PureComponent<IBasicLayoutProps, any> {
  private static defaultProps = {
    showHeader: true,
    showHero: true,
    showIntegrations: true,
    showCta: true,
    showFooter: true,
    priceComponent: false
  };

  public render() {
    return (
      <div>
        {this.props.showHeader && <Header />}
        {this.props.showHeader && <Header isSticky={true} />}
        {this.props.showHero && (
          <Hero
            title={this.props.heroTitle}
            subtitle={this.props.heroSubtitle ? this.props.heroSubtitle : null}
          />
        )}
        <this.props.variableComponent>
          {this.props.pageContent}
        </this.props.variableComponent>
        {this.props.showIntegrations && (
          <Integrations isPrice={this.props.priceComponent} />
        )}
        {this.props.showCta && <Subscription />}
        {this.props.showFooter && <Footer />}
        <CookieConsent />
      </div>
    );
  }
}

export default BasicLayout;



// WEBPACK FOOTER //
// ./src/layouts/basic-layout.tsx